import React from 'react'

import {TableHeaderRow} from "@devexpress/dx-react-grid-material-ui"
import {Filter} from "./Filter"

export const TableHeaderContent = (props) => {
    const {column, id, children, ...restProps} = props

    let button = null

    switch (column.name) {
        case 'attribute':
        case 'created':
            button = <Filter name={column.name} id={id}/>
            break
        default:
            break
    }

    return (
        <TableHeaderRow.Content
            column={column}
            {...restProps}
            style={{
                justifyContent: 'space-between'
            }}
        >
            {children}
            {button}
        </TableHeaderRow.Content>
    )
}
